import { formatDateIfValid } from '../formatDateIfValid';

export const formatDateToDateInputValue = (date: Date | string) => {
  const datePattern = 'YYYY-MM-DD';
  const formatTemplate = datePattern;

  return formatDateIfValid(date, {
    formatTemplate,
    fallbackValue: '',
  });
};

export const formatedDateToDate = (dateString: string): Date | null => {
  if (!dateString) {
    return null;
  }
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day); // Mês começa d
  return date;
};
